import { Navigate, useLocation } from 'react-router';
import { route, useAuthBootstrap } from '@hero/web-hooks';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const location = useLocation();
  const { isBootstrapping, isLoggedIn } = useAuthBootstrap();

  // While the boot-time silent refresh is in flight we cannot yet
  // tell "signed out" from "waiting on /auth/refresh". Render a
  // spinner instead of redirecting — otherwise every hard reload
  // bounces the user to the login screen even when their HttpOnly
  // `hero_rt` cookie is still valid.
  if (isBootstrapping) {
    return (
      <div className="min-h-screen bg-muted flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600" />
      </div>
    );
  }

  if (!isLoggedIn) {
    return <Navigate to={route('auth_register')} state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
